
export const TermsAndConditions = () => <div className='text-[#606060] text-right'>
    <p><a href="https://rtkdirect.com/terms-and-conditions/" target="_blank" rel="noreferrer">Terms and Conditions</a></p>
    <p>Copyright 2019 - {new Date().getFullYear()} © RTK Direct</p>
</div>
